import { ActionIcon, Box, Group, Text } from "@mantine/core";
import { IconEdit } from "@tabler/icons-react";
import { useAppSelector } from "app/hooks";
import { BoardingResource, OrgPermissions } from "beitary-shared";
import {
  ArchiveConfirmationModal,
  BDataTable,
  DearchiveConfirmationModal,
  DeleteConfirmationModal,
} from "components";
import { selectBoardingResources } from "features/admin/schedule-settings/ScheduleSettings.slice";
import { useDBServices } from "hooks/useDBService/useDBService";
import { BCan } from "permissions";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { BDataTableColumn } from "schemas-types";

type BoardingResourcesTableItem = BoardingResource & {
  actions?: undefined;
};

export const BoardingResourcesTable = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const boardingResources = useAppSelector(selectBoardingResources);

  const tableItems: BoardingResourcesTableItem[] = boardingResources.map(
    (boardingResource) => ({
      ...boardingResource,
    })
  );

  const {
    deleteBoardingResource,
    archiveBoardingResource,
    dearchiveBoardingResource,
  } = useDBServices().scheduleSettingsDBService.boardingResources;

  const columns: BDataTableColumn<BoardingResourcesTableItem>[] = [
    {
      accessor: "name",
      title: <Text>{t("NAME")}</Text>,
      sortable: true,
    },
    {
      accessor: "color",
      title: <Text>{t("COLOR")}</Text>,
      sortable: true,
      render: ({ color }) => (
        <Box
          sx={{
            backgroundColor: color,
            borderRadius: 10,
            width: 20,
            height: 20,
          }}
        ></Box>
      ),
    },
    {
      accessor: "status",
      title: <Text>{t("STATUS")}</Text>,
      sortable: true,
      render: ({ status }) => (
        <Text color={status === "ACTIVE" ? "dark" : "dimmed"}>{t(status)}</Text>
      ),
    },
    {
      accessor: "description",
      title: <Text>{t("DESCRIPTION")}</Text>,
      sortable: true,
    },
    {
      accessor: "actions",
      title: "",
      width: 140,
      render: (boardingResource) => (
        <BCan I="do" a={OrgPermissions.SCHEDULE_CUD}>
          <Group position="right">
            <ActionIcon onClick={() => navigate(`edit/${boardingResource.id}`)}>
              <IconEdit size={18} />
            </ActionIcon>
            {boardingResource.status === "ARCHIVED" ? (
              <DearchiveConfirmationModal
                f={async () => dearchiveBoardingResource(boardingResource.id)}
                item={boardingResource}
              />
            ) : (
              <ArchiveConfirmationModal
                f={async () => archiveBoardingResource(boardingResource.id)}
                item={boardingResource}
              />
            )}
            <DeleteConfirmationModal
              f={async () => deleteBoardingResource(boardingResource.id)}
              item={boardingResource}
            />
          </Group>
        </BCan>
      ),
    },
  ];

  return (
    <BDataTable data={tableItems} columns={columns} defaultSortKey={"name"} />
  );
};
